import { ProductClassification } from 'enums';
import { productFormatter } from 'utils';

export type ApplicableProduct =
  | ProductClassification.ZipMoney
  | ProductClassification.ZipPay
  | ProductClassification.ZipPlus;

export interface ProductDebrief {
  MenuTitle: string;
  MenuSubtitle: string;
  IntroductionTitle: string;
  CreditLimit: string;
  Explanation: string[];
  TermsConditions: string;
}

export const ProductDetails = new Map<ApplicableProduct, ProductDebrief>([
  [
    ProductClassification.ZipMoney,
    {
      MenuTitle: productFormatter(ProductClassification.ZipMoney),
      MenuSubtitle: 'Bigger purchases',
      IntroductionTitle: "For life's bigger purchases",
      CreditLimit: 'Up to $50,000 credit',
      Explanation: [
        'Interest free for up to 5 years at select Zip partners',
        'Flexible repayments starting from $10/week',
        'Any balance outstanding at the expiry of the interest free period will be charged at the standard variable rate of 25.9% p/a. Interest, fees and charges are subject to change. Interest free term subject to minimum spend and promotional merchant offers',
        'Transaction maximums apply between interest free periods',
      ],
      TermsConditions: 'https://zip.co/au/zip-money',
    },
  ],

  [
    ProductClassification.ZipPay,
    {
      MenuTitle: productFormatter(ProductClassification.ZipPay),
      MenuSubtitle: 'Everyday account',
      IntroductionTitle: 'For everyday spend',
      CreditLimit: 'Up to $1,500 credit',
      Explanation: [
        'Interest free, always',
        'Customers can spend everywhere Visa is accepted with the Zip Pay Visa card or directly at partnered merchants',
        'Flexible repayments starting from $10/week',
      ],
      TermsConditions: 'https://zip.co/au/zip-pay',
    },
  ],

  [
    ProductClassification.ZipPlus,
    {
      MenuTitle: productFormatter(ProductClassification.ZipPlus),
      MenuSubtitle: 'Everyday, plus more',
      IntroductionTitle: 'For everyday, plus more',
      CreditLimit: 'Up to $8,000 credit',
      Explanation: [
        'Interest free when your end of month balance is under $1,500',
        "12.95% p.a. when a customer's owing balance at the end of each month is over $1,500",
        'Customers can spend everywhere Visa is accepted with the Zip Plus Visa card or directly at partnered merchants',
        'Flexible repayments starting from $20/week',
      ],
      TermsConditions: 'https://zip.co/au/zip-plus',
    },
  ],
]);

export const AllApplicableProductsInOrder: ApplicableProduct[] = [
  ProductClassification.ZipMoney,
  ProductClassification.ZipPay,
  ProductClassification.ZipPlus,
];
